export const LANDING_ROUTE = "/";

export const APP_BASE_ROUTE = "/app";
export const APP_DASHBOARD_ROUTE = APP_BASE_ROUTE;
export const APP_REVENUE_EXPENSES_ROUTE = "/app/receitaxdespesa";
export const APP_BUDGET_ROUTE = "/app/orcamento";
export const APP_GOALS_ROUTE = "/app/metas";
export const APP_OPERATION_ROUTE = "/app/operation";
export const APP_OPERATION_EXTRACT_ROUTE = "/app/operation/extract";
export const APP_DIVIDENDS_ROUTE = "/app/dividendos";
export const APP_POSITION_ROUTE = "/app/posicao";
export const APP_REBALANCE_ROUTE = "/app/rebalancear";
export const APP_REBALANCE_SCORE_ROUTE = "/app/rebalancear/pontuar";
export const APP_CALCULATOR_ROUTE = "/app/calculadora";
export const APP_CHECKOUT_ROUTE = "/app/checkout";
export const APP_PAYMENT_ROUTE = "/app/pagamento";
export const APP_MARKET_ROUTE = "/app/mercado";
export const APP_SETTINGS_ROUTE = "/app/configuracoes";

export const SIGN_IN_ROUTE = "/entrar";
export const SIGN_UP_ROUTE = "/criar-conta";
export const LOGOUT_ROUTE = "/sair";
export const RESET_PASSWORD_ROUTE = "/esqueci-senha";
export const RESET_PASSWORD_FORM_ROUTE = "/redefinir-senha";

export const LEGACY_SIGN_IN_ROUTE = "/authentication/sign-in";
export const LEGACY_SIGN_UP_ROUTE = "/authentication/sign-up";
export const LEGACY_LOGOUT_ROUTE = "/authentication/logout";
export const LEGACY_RESET_PASSWORD_ROUTE = "/authentication/reset-password";
export const LEGACY_RESET_PASSWORD_FORM_ROUTE = "/authentication/reset-password-form";

export const LEGACY_DASHBOARD_ROUTE = "/dashboard";
export const LEGACY_REVENUE_EXPENSES_ROUTE = "/receitaxdespesa";
export const LEGACY_BUDGET_ROUTE = "/orcamento";
export const LEGACY_GOALS_ROUTE = "/metas";
export const LEGACY_OPERATION_ROUTE = "/operation";
export const LEGACY_OPERATION_EXTRACT_ROUTE = "/operation/extract";
export const LEGACY_DIVIDENDS_ROUTE = "/dividendos";
export const LEGACY_POSITION_ROUTE = "/posicao";
export const LEGACY_REBALANCE_ROUTE = "/rebalancear";
export const LEGACY_REBALANCE_SCORE_ROUTE = "/rebalancear/pontuar";
export const LEGACY_CALCULATOR_ROUTE = "/calculadora";
export const LEGACY_CHECKOUT_ROUTE = "/checkout";
export const LEGACY_PAYMENT_ROUTE = "/pagamento";
export const LEGACY_MARKET_ROUTE = "/mercado";
export const LEGACY_APP_DASHBOARD_ROUTE = "/app/dashboard";

export const isAppRoute = (pathname = "") =>
  pathname === APP_BASE_ROUTE || pathname.startsWith(`${APP_BASE_ROUTE}/`);
